import React from 'react';
import { connect } from 'react-redux';
import CreateSystemForm from './CreateSystem/CreateSystemFormTS';
import CreateNodeForm from './CreateNode/CreateNodeForm';
import CreateUser from './CreateUser/CreateUser';
import PinUser from './PinUser/PinUser';
import CreateSystemGroupForm from './CreateSystemGroup/CreateSystemGroupForm';
import AddSystemsToGroupForm from './AddSystemsToGroup/AddSystemsToGroupForm';
import AddUsersToSystemGroupForm from './AddUsersToSystemGroup/AddUsersToSystemGroupForm';
import DeleteSystem from './DeleteSystem/DeleteSystem';
import ArchiveSystem from './ArchiveSystem/ArchiveSystem';
import DeleteNodeFromSystem from './DeleteNodeFromSystem/DeleteNodeFromSystem';
import DeleteUser from './DeleteUser/DeleteUser';
import BindDeviceToNode from './BindDeviceToNode';
import ResetSensorErrorCountsCard from '../../components/ResetSensorErrorCounts/ResetSensorErrorCountsCard';
import { Grid } from '@material-ui/core';
import { getSystemsForInstallerPanel } from '../../stores/actions/installerActions';
import { SYSTEM_VERSIONS } from '../../helpers/Systems';
import { getVisibleAccounts } from '../../stores/actions/actions';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import _ from 'lodash';

interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
  }
  
  function CustomTabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;
  
	return (
	  <div
		role="tabpanel"
		hidden={value !== index}
		id={`simple-tabpanel-${index}`}
		aria-labelledby={`simple-tab-${index}`}
		{...other}
	  >
		{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
	  </div>
	);
  }

interface IInstallerPanelProps {
	mobileView: boolean;
	accountCategory: string;
	getSystemsForInstallerPanel: () => void;
	getVisibleAccounts: () => void;
}

class InstallerPanel extends React.Component<IInstallerPanelProps> {
    state = {
        value: 0,
    };

	componentWillMount(): void {
		this.props.getSystemsForInstallerPanel();
		this.props.getVisibleAccounts();
	}
	handleChange = (event, newValue) => {
		this.setState({value: newValue});
	  };

	render() {
		const { mobileView, systems, accounts, accountCategory } = this.props;
		const sortedSystems = [...systems].sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1);
		return (
			<Box sx={{ width: '100%' }}>
			<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
			  <Tabs value={this.state.value} onChange={(e, newVal) => this.handleChange(e, newVal)} variant="fullWidth" centered>
			  <Tab label="Users"/>
			  <Tab label="Systems"/>
			  <Tab label="System Groups"/>
			  </Tabs>
			</Box>
			{this.state.value == 0 ?
			<CustomTabPanel value={this.state.value} index={0}>
				<Grid container spacing={2}>
					<Grid item xs={mobileView ? 12 : 6}>
						<CreateUser 
							accounts={accounts}
							// systems={sortedSystems}
						/>
					</Grid>
					<Grid item xs={mobileView ? 12 : 6}>
						<PinUser 
							systems={sortedSystems}
						/>
					</Grid>
				</Grid>	
				<Grid container spacing={2}>
					<Grid item xs={mobileView ? 12 : 6}>
						<DeleteUser />
					</Grid>
				</Grid>
			</CustomTabPanel>
			: this.state.value == 1 ?
			<CustomTabPanel value={this.state.value} index={1}>
			<Grid container spacing={2} direction={mobileView ? 'column' : 'row'}>
					<Grid item xs={mobileView ? 12 : 6}>
						<CreateSystemForm />
					</Grid>
					<Grid item xs={mobileView ? 12 : 6}>
						<DeleteSystem/>
					</Grid>
			</Grid>
			<Grid container spacing={2} direction={mobileView ? 'column' : 'row'}>
					<Grid item xs={mobileView ? 12 : 6}>
						<CreateNodeForm 
							systems={_.filter(sortedSystems, { systemVersion: SYSTEM_VERSIONS.W4 })}
						/>
					</Grid>
					<Grid item xs={mobileView ? 12 : 6}>
						<DeleteNodeFromSystem/>
					</Grid>
			</Grid>
			<Grid container spacing={2} direction={mobileView ? 'column' : 'row'}>
					<Grid item xs={mobileView ? 12 : 6}>
						<BindDeviceToNode
							systems={_.filter(sortedSystems, { systemVersion: SYSTEM_VERSIONS.W4 })}
						/>
					</Grid>
					<Grid item xs={mobileView ? 12 : 6}>
						<ArchiveSystem/>
					</Grid>
			</Grid>
			{accountCategory === 'wisene' && (
			<Grid container spacing={2} direction={mobileView ? 'column' : 'row'}>
					<Grid item xs={mobileView ? 12 : 6}>
						<ResetSensorErrorCountsCard />
					</Grid>
			</Grid>
			)}
			</CustomTabPanel>
			: 			
			<CustomTabPanel value={this.state.value} index={2}>
			<Grid container spacing={2}>
					<Grid item xs={mobileView ? 12 : 6}>
						<CreateSystemGroupForm 
						/>
					</Grid>
				</Grid>
				<Grid container spacing={2}>
				<Grid item xs={mobileView ? 12 : 6}>
						<AddSystemsToGroupForm 
							systems={sortedSystems}
						/>
					</Grid>
					<Grid item xs={mobileView ? 12 : 6}>
						<AddUsersToSystemGroupForm 
							accounts={accounts}
						/>
					</Grid>
				</Grid>
			</CustomTabPanel>}
			</Box>
			
		);
	}
}

const mapStateToProps = (state) => {
	return {
		mobileView: state.dashboard.mobileView,
		systems: state.installer.systemsForInstallerPanel || [],
		accounts: state.dashboard.accounts,
		accountCategory: state.login.accountCategory
	};
};

const actions = { getSystemsForInstallerPanel, getVisibleAccounts };

export default connect(mapStateToProps, actions)(InstallerPanel);
